import { updateProduct } from '../api/products';
import {
  ProductMutationPayload,
  StockReductionConflict,
} from '../types';

const getStockReductionConflict = (
  error: unknown,
): StockReductionConflict | null => {
  const data = (error as any)?.response?.data;

  if (
    data?.code !== 'STOCK_REDUCTION_CONFIRMATION_REQUIRED' ||
    typeof data.confirmationKey !== 'string' ||
    !Array.isArray(data.warnings)
  ) {
    return null;
  }

  return data as StockReductionConflict;
};

const formatStockReductionWarning = (conflict: StockReductionConflict) => {
  const warningLines = conflict.warnings.map((warning) => {
    const result =
      warning.remainingQuantity < 0
        ? `${Math.abs(warning.remainingQuantity)}개 부족`
        : '남음 0개';

    return `- ${warning.name}: 입고 ${warning.incomingQuantity}개 / 주문 ${warning.orderedQuantity}개 (${result})`;
  });

  return `입고량을 현재 주문량 이하로 줄이려고 합니다.\n\n${warningLines.join('\n')}\n\n기존 주문은 자동으로 취소되지 않습니다. 그래도 수정하시겠습니까?`;
};

export const updateProductWithStockConfirmation = async (
  id: string,
  updates: ProductMutationPayload,
) => {
  let nextUpdates = updates;

  while (true) {
    try {
      return await updateProduct(id, nextUpdates);
    } catch (error) {
      const conflict = getStockReductionConflict(error);
      if (!conflict) {
        throw error;
      }

      if (!window.confirm(formatStockReductionWarning(conflict))) {
        return null;
      }

      nextUpdates = {
        ...updates,
        stockReductionConfirmationKey: conflict.confirmationKey,
      };
    }
  }
};
